import { LngLat } from "mapbox-gl";
import { useEffect } from "react";
import { MapRef, useMap } from "react-map-gl";
import { useMapStore, useViewSettingsStore } from "..";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import MapStore from "../store/MapStore";

var counter = 0;

export default function (coordinates: IGeoCoordinate, initiatorType: InitiatorType) {
    const map = useMap().map!;
    const mapStore = useMapStore();
    const viewSettingsStore = useViewSettingsStore();

    useEffect(() => {
        if ((viewSettingsStore.isMobile && initiatorType === InitiatorType.Details) || (!viewSettingsStore.isMobile && initiatorType === InitiatorType.Popup))
            flyTo(coordinates, map, mapStore);
    }, [coordinates]);
}

const flyTo = (coordinates: IGeoCoordinate, map: MapRef, mapStore: MapStore) => {
    setTimeout(() => {
        const flyInstanceId = ++counter;
        const zoom = mapStore.viewState.zoom > 14 ? mapStore.viewState.zoom : 16;
        const reducedMotion = !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

        if (reducedMotion) {
            mapStore.setViewState({
                longitude: coordinates.longitude,
                latitude: coordinates.latitude,
                zoom,
            });
            return;
        }

        map.flyTo({
            center: new LngLat(coordinates.longitude, coordinates.latitude),
            duration: 1000,
            zoom,
        });

        // jump forward to coordinates if map.stop() is called
        map.once('moveend', () => {
            if (flyInstanceId === counter) {
                setTimeout(() => {
                    map.flyTo({
                        center: new LngLat(coordinates.longitude, coordinates.latitude),
                        duration: 0,
                        zoom,
                    });
                }, 10);
            }
        });
    }, 10); // fly after map resize is done
};

export enum InitiatorType {
    Popup,
    Details,
}
